import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminPembimbing from "@/pages/AdminPembimbing";
import AdminPerizinan from "@/pages/AdminPerizinan";
import AdminGaleri from "@/pages/AdminGaleri";
import AdminArtikel from "@/pages/AdminArtikel";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import SantriDashboard from "@/pages/SantriDashboard";
import PembimbingDashboard from "@/pages/PembimbingDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/artikel" element={<Articles />} />
            <Route path="/artikel/:slug" element={<ArticleDetail />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pembimbing"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AdminPembimbing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/perizinan"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AdminPerizinan />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/galeri"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AdminGaleri />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/artikel"
              element={
                <ProtectedRoute allow={["admin"]}>
                  <AdminArtikel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/santri"
              element={
                <ProtectedRoute allow={["santri"]}>
                  <SantriDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pembimbing"
              element={
                <ProtectedRoute allow={["pembimbing"]}>
                  <PembimbingDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
